module.exports = __webpack_public_path__ + "static/riley-on-set-608ccbf5711fb03744e68e0ae52555d8.jpg";